var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Payments"}},[_c('input-money',{attrs:{"value":_vm.mortgage.payments,"name":"payments","read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }